import React from 'react';
import styled from 'styled-components';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import { useAdminSystemAlert } from '../../share/hook/useAdminSystemAlert';

const SupportColumnInfo: React.FC = () => {
  const { activeSystemAlert } = useAdminSystemAlert();

  return (
    <ColumnInfoComp>
      <InfoContainer>
        <TitleBlock>Type</TitleBlock>
        <AdminBlockWithVisible
          width={"1.5"}
          isColumn={true}
          value={"Message"}
        />
        <AdminBlockWithVisible
          width={"1"}
          isColumn={true}
          value={"CreatedAt"}
        />
        <AdminBlockWithVisible
          width={"1.5"}
          isColumn={true}
          value={"Scheduled StartDate"}
        />
        <AdminBlockWithVisible
          width={"1.5"}
          isColumn={true}
          value={"Scheduled EndDate"}
        />
        <AdminBlockWithVisible
          width={"1"}
          isColumn={true}
          value={"EndedAt"}
        />
        {activeSystemAlert && <SpaceBlock />}
      </InfoContainer>
      {activeSystemAlert &&
        <OverviewBlock>Overview</OverviewBlock>
      }
    </ColumnInfoComp>
  );
};


const ColumnInfoComp = styled.article`
  width: 100%;
  height: 38px;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_02};

  ${({ theme }) => theme.typography.Body_03_2};
`;

const InfoContainer = styled.article`
  flex: 1;
  width: auto;
  height: 34px;
  display: flex;
`;
const TitleBlock = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding-left: 10px;
`

const SpaceBlock = styled.div`
  flex: 0.15;
  display: flex;
  align-items: center;
  justify-content: center;
`

const OverviewBlock = styled.div`
  width: 29vw;
  display: flex;
  align-items: center;
`

export default SupportColumnInfo;